import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const useCategoryPill = ({ builderModelname, data = [] }) => {
  const navigate = useNavigate()
  useEffect(() => {
    if (builderModelname !== 'category-pill-listing' || !Array.isArray(data)) {
      return
    }
    const handleClick = (e) => {
      const span = e.target.closest(
        'div[data-name="category-pill-listing"] span[role="button"]'
      )
      if (!span) return
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      const button_text = span.textContent.trim()

      const slug = data.find(
        ({ categoryName }) =>
          categoryName?.toLowerCase() === button_text.toLowerCase()
      )?.categorySlug

      if (slug) {
        const button_url = `/class-finder?styles=${slug}&order=date`
        window.dataLayer ||= []
        window.dataLayer.push({ event: 'style_click', button_text, button_url })
        navigate(button_url)
      }
    }
    document.addEventListener('click', handleClick, true)
    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [builderModelname, data, navigate])

  return null
}

export default useCategoryPill
